import { render, staticRenderFns } from "./GiftcardBlob.vue?vue&type=template&id=4ed31a72&scoped=true"
import script from "./GiftcardBlob.vue?vue&type=script&lang=js"
export * from "./GiftcardBlob.vue?vue&type=script&lang=js"
import style0 from "./GiftcardBlob.vue?vue&type=style&index=0&id=4ed31a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed31a72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
